import React, { Component } from 'react'
import PropTypes from 'prop-types'
import SyncedStore from '../../../stores/SyncedStore'
import { Button, Form, Grid, Header, Pagination, Table } from 'semantic-ui-react'
import LoadingWrapper from '../../../components/LoadingWrapper'
import { Link } from 'react-router-dom'
import Input from '../../../components/Forms/Input'
import Checkbox from '../../../components/Forms/Checkbox'
import { inject, observer } from 'mobx-react'

@inject('syncedStore')
@observer
class ClientsSyncedScreen extends Component {
  static propTypes = {
    syncedStore: PropTypes.instanceOf(SyncedStore)
  }

  constructor (props) {
    super(props)
    window.document.title = 'Liste de clients synchronisés'
  }

  componentDidMount () {
    const { syncedStore } = this.props
    syncedStore.loadAll()
  }

  changePage = (page) => {
    const { syncedStore } = this.props
    syncedStore.changePage(page.activePage)
    syncedStore.loadAll()
  }

  handleSendFilters = () => {
    const { syncedStore } = this.props
    syncedStore.sendFilters()
    syncedStore.loadAll()
  }

  handleClearFilters = () => {
    const { syncedStore } = this.props
    syncedStore.clearFilters()
    syncedStore.loadAll()
  }

  render () {
    const { syncedStore } = this.props
    const { paging, syncedList, isLoading } = syncedStore
    return (
      <>
        <Header as='h2'>Liste de clients synchronisés</Header>
        <LoadingWrapper loading={isLoading} message='Chargement en cours...' />
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <Header as='h3'>Filtrer par:</Header>
              <Form>
                <Form.Group widths='equal'>
                  <Input name='_tmpQuery.PK_Number' label='Code' store={syncedStore} />
                  <Input name='_tmpQuery.CuName' label='Nom Contact' store={syncedStore} />
                  <Input name='_tmpQuery.address' label='Adresse' store={syncedStore} />
                </Form.Group>
                <Checkbox name='_tmpQuery.showAll' label='Afficher les clients déjà importés' store={syncedStore} />
                <Button primary onClick={this.handleSendFilters}>Filtrer</Button>
                <Button primary onClick={this.handleClearFilters}>Effacer</Button>
              </Form>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              {paging.ClientsSynced && <Pagination
                onPageChange={(e, data) => this.changePage(data)}
                totalPages={paging.ClientsSynced.pageCount}
                activePage={paging.ClientsSynced.page}
                                       />}
              {!!syncedList.length &&
                <Table celled>
                  <Table.Header key='header'>
                    <Table.Row>
                      <Table.HeaderCell>Code</Table.HeaderCell>
                      <Table.HeaderCell>Nom</Table.HeaderCell>
                      <Table.HeaderCell>Contact</Table.HeaderCell>
                      <Table.HeaderCell>Adresse</Table.HeaderCell>
                      <Table.HeaderCell>Téléphone</Table.HeaderCell>
                      <Table.HeaderCell>Télécopieur</Table.HeaderCell>
                      <Table.HeaderCell>Courriel</Table.HeaderCell>
                      <Table.HeaderCell>Adresses Supplémentaires</Table.HeaderCell>
                      <Table.HeaderCell>Actions</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body key='body'>
                    {syncedList.map(synced => {
                      let url = <Link to={`/clients/synced/${synced.PK_Number}`}>importer</Link>
                      if (synced.client) {
                        url = <Link to={`/clients/view/${synced.client.id}`}>voir client</Link>
                      } else if (synced.CuInvoicedToNumber) {
                        url = (
                          <Link
                            to={`/clients/synced/${synced.CuInvoicedToNumber}?highlight=${synced.PK_Number}`}
                          >importer
                          </Link>
                        )
                      }
                      return (
                        <Table.Row key={`synced_${synced.PK_Number}`}>
                          <Table.Cell>
                            {synced.PK_Number}
                          </Table.Cell>
                          <Table.Cell>
                            {synced.CuName}
                          </Table.Cell>
                          <Table.Cell>
                            {synced.CuCareOf}
                          </Table.Cell>
                          <Table.Cell>
                            {synced.fullAddress}
                          </Table.Cell>
                          <Table.Cell>
                            {synced.CuPhoneNumber1}
                          </Table.Cell>
                          <Table.Cell>
                            {synced.CuPhoneNumber2}
                          </Table.Cell>
                          <Table.Cell>
                            {synced.CuEmail}
                          </Table.Cell>
                          <Table.Cell>
                            {!!synced.clients_childs_synced.length && (
                              <Link to={`/clients/synced/${synced.PK_Number}`}>afficher</Link>
                            )}
                          </Table.Cell>
                          <Table.Cell>
                            {url}
                          </Table.Cell>
                        </Table.Row>
                      )
                    })}
                  </Table.Body>
                </Table>}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </>
    )
  }
}

export default ClientsSyncedScreen
